import React, { useEffect, useState } from 'react';

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import m1 from '../../img/MarketsCrypto/main-desktop.png';
import m2 from '../../img/MarketsCrypto/main-mobile.png';

function Main () {

    const { t } = useTranslation();

    const blocks = ['Bitcoin', 'Ethereum', 'Cardano', 'Polygon'];
    const [activeIndex, setActiveIndex] = useState(0);
  
    useEffect(() => {
      const interval = setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % blocks.length);
      }, 3000); // смена каждые 3 секунды
  
      return () => clearInterval(interval);
    }, []);
      
    return(
        <div className="relative bg-[#1A1A72] max-w-[1920px] mx-auto pt-[60px] xl:pt-[100px] overflow-hidden">
            <div className="max-w-[1520px] mx-auto">
                <img src={m1} alt="" className="absolute hidden md:block object-cover"/>
                <img src={m2} className='md:hidden absolute w-full h-full object-cover' alt="" />
                <div className="max-w-[1220px] xl:mx-auto relative pt-[90px]">
                    <div className="flex flex-col items-center">
                        <p className="text-center mx-[20px] xl:mx-0 open-sans spantext2 text-[#FFF] font-[700] text-[28px] xl:text-[45px]"><Trans>{t('marketscrypto.1')}</Trans></p>
                        <p className="mt-[15px] mx-[20px] xl:mx-0 text-[17px] xl:text-[19px] font-[600] text-[#FFF] open-sans xl:max-w-[662px] text-center"><Trans>{t('marketscrypto.2')}</Trans></p>
                        <Button color={'#EFEFEF'} text={'#0C2780'} className={'mt-[30px] xl:mt-[50px]'}/>             
                        <div className="flex flex-wrap xl:flex-nowrap xl:h-[118px] w-full mt-[90px]">
                            {blocks.map((name, index) => (
                                <div
                                    key={name}
                                    className={`h-[63px] w-[186px] flex-grow xl:h-full xl:w-full border-r flex items-center relative transition-colors duration-700 ${
                                    index === activeIndex ? 'bg-[#63ABFF]' : 'bg-[#0C2FA3CC]'
                                }`}
                                >
                                    <p className="text-[#EFEFEF] open-sans font-[600] text-[16px] px-[40px]">
                                        {name}
                                    </p>
                                    <svg
                                        className="absolute bottom-[17px] right-[30px]"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="25"
                                        viewBox="0 0 24 25"
                                        fill="none"
                                    >
                                        <path
                                        d="M5 12.0156L19 12.0156"
                                        stroke="#EFEFEF"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        />
                                        <path
                                        d="M12 19.0156L19 12.0156L12 5.01562"
                                        stroke="#EFEFEF"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;